import { errorLogger } from '@ajaibid/utils';
import fetcher from '@helpers/fetcher';

/**
 * @returns {string}
 */
function getUrl() {
  return 'v1/stock/odt/order/historytrade-filter/';
}

/**
 * @typedef   {object}    HistoryListDtParams
 *
 * @property  {string?}   transactionType
 * @property  {string?}   statusType
 * @property  {number?}   pageSize
 */

/**
 * @typedef   {'day'|'sesi'}  OrderPeriodDt
 */

/**
 * @typedef   {object}    HistoryDt
 *
 * @property  {any[]}     automation_order_item_types   (Ex: [])
 * @property  {string}    idx_order_no                  (Ex: "202306140000030291")
 * @property  {string}    idx_trade_no                  (Ex: "202306140000017210")
 * @property  {number}    lot                           (Ex: 125)
 * @property  {string}    market_type                   (Ex: "0RG")
 * @property  {string}    order_no                      (Ex: "20202")
 * @property  {number}    price_matched                 (Ex: 120)
 * @property  {number}    shares                        (Ex: 125)
 * @property  {string}    status_description            (Ex: "Matched")
 * @property  {string}    stock                         (Ex: "GOTO")
 * @property  {number}    total_price                   (Ex: 1500000)
 * @property  {string}    trade_date                    (Ex: "2023-06-14T14:45:02.000+07:00")
 * @property  {string}    transaction_type              (Ex: "1")
 */

/**
 * @typedef   {object}  HistoryListDtPaging
 *
 * @property  {number}    count                 (Ex: 22)
 * @property  {string?}   next
 * @property  {number}    page                  (Ex: null)
 * @property  {string?}   previous              (Ex: null)
 * @property  {number}    total_pages
 */

/**
 * @typedef   {object}  HistoryListMtResponse
 * @property  {object}                data
 * @property  {string}                data.err_code      (Ex: "EC0000000")
 * @property  {string}                data.err_message   (Ex: "APPROVED/OK")
 * @property  {HistoryListDtPaging}   data.paging
 * @property  {HistoryDt[]}           data.results
 *
 * @property  {number}                status            (Ex: 200)
 * @property  {string}                statusText        (Ex: '')
 */

/**
 *
 * @param {string}              url
 * @param {HistoryListDtParams} historyListParams
 * @returns
 */
function callbackFetch(url, { pageSize, statusType, transactionType }) {
  return async ({ pageParam = 1 }) => {
    try {
      /**
       * @type {HistoryListMtResponse}
       */
      const res = await fetcher.get(url, {
        params: {
          page: pageParam,
          transaction_type: transactionType,
          status_type: statusType,
          page_size: pageSize,
        },
      });

      return res.data;
    } catch (err) {
      errorLogger('ERROR_API', err.message);
      throw err;
    }
  };
}

/**
 * @param {HistoryListDtParams} historyListParams
 * @returns
 */
export default function getV1StockOdtOrderHistorytradefilter(historyListParams = { pageSize: 15 }) {
  const url = getUrl();
  const cb = callbackFetch(url, historyListParams);
  const key = [url, JSON.stringify(historyListParams)];

  return { cb, key };
}
